"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react');

// Further than this from the press, at any point before release, is a drag,
// not a click.
 const DRAG_THRESHOLD_PX = 5; exports.DRAG_THRESHOLD_PX = DRAG_THRESHOLD_PX

/* A mouse drag that starts and ends on the same row or tab would land as a
 * click on it and open the chat or pick the tab. Put these on the list's root:
 * a click that ends a drag stops there, even one that came back to where it
 * started. */
 const useDragGuard = () => {
  const pressRef = _react.useRef(null)
  const stopWatchingRef = _react.useRef(null)

  const stopWatching = _react.useCallback.call(void 0, () => {
    _optionalChain([stopWatchingRef, 'access', _ => _.current, 'optionalCall', _2 => _2()])
    stopWatchingRef.current = null
  }, [])
  _react.useEffect.call(void 0, () => stopWatching, [stopWatching])

  const onPointerDownCapture = _react.useCallback.call(void 0, (e) => {
    stopWatching()
    const press = { x: e.clientX, y: e.clientY, dragged: false }
    pressRef.current = press
    // On the window, so a drag that leaves the list and comes back still counts.
    const onMove = (m) => {
      if (Math.hypot(m.clientX - press.x, m.clientY - press.y) > exports.DRAG_THRESHOLD_PX) {
        press.dragged = true
        stopWatching()
      }
    }
    window.addEventListener('pointermove', onMove)
    window.addEventListener('pointerup', stopWatching)
    window.addEventListener('pointercancel', stopWatching)
    stopWatchingRef.current = () => {
      window.removeEventListener('pointermove', onMove)
      window.removeEventListener('pointerup', stopWatching)
      window.removeEventListener('pointercancel', stopWatching)
    }
  }, [stopWatching])

  const onClickCapture = _react.useCallback.call(void 0, (e) => {
    const press = pressRef.current
    pressRef.current = null
    // A keyboard "click" (Enter, Space) has no press.
    if (!press || e.detail === 0) return
    if (press.dragged || Math.hypot(e.clientX - press.x, e.clientY - press.y) > exports.DRAG_THRESHOLD_PX) {
      e.preventDefault()
      e.stopPropagation()
    }
  }, [])

  return { onPointerDownCapture, onClickCapture }
}; exports.useDragGuard = useDragGuard
